import { useAuthenticatedFetch } from "../../../lib/api";
import type { RebalanceAuditResponse } from "../lib/explainTypes";

interface ApiResponse<T> {
  data: T;
}

// Third react-query cache stream on the v3 Explain tree (D8), keyed
// `/rebalances/:id/audit` — exactly as `useExplain` / `ChecksPanel` key their
// streams. This hook is CACHE-ONLY (`enabled: false`): the only producer of
// the cache entry is the admin viewer, which primes this key via
// `setQueryData` BEFORE the tree mounts; a disabled query still surfaces that
// primed data. It NEVER issues its own GET — that is what the AC5 fetch-spy
// asserts on the admin path, and (critically) on the firm-scoped / manual
// paths it avoids firing a request at the firm `/rebalances/:id/audit`
// endpoint, which is DEFERRED this iteration (R12) and would 404. When R12
// lands, flip `enabled` to gate on a present id so the firm path fetches.
export function useAudit(rebalanceId: number | undefined) {
  return useAuthenticatedFetch<ApiResponse<RebalanceAuditResponse | null>>(
    `/rebalances/${rebalanceId}/audit`,
    {},
    { staleTime: Infinity, enabled: false },
    [`/rebalances/${rebalanceId}/audit`],
  );
}
